(function () {
  var AWAY_TITLE = 'Miau, vergiss mich nicht! 🐾';

  // Beim Seitenaufruf sichern ...
  var originalTitle = document.title;

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      // ... und beim Verlassen aktualisieren: falls ein anderes Script
      // (z.B. Warenkorb-Zaehler) den Titel geaendert hat, wird genau
      // dieser aktuelle Titel wiederhergestellt.
      if (document.title !== AWAY_TITLE) {
        originalTitle = document.title;
      }
      document.title = AWAY_TITLE;
    } else {
      document.title = originalTitle;
    }
  });
})();
